import * as getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  lessonStep: {
    byId: {},
    allIds: []
  },
  lesson: {
    byId: {},
    allIds: []
  },
  theme: {
    byId: {},
    allIds: []
  },
  lessonStepProgress: {
    byId: {}
  },
  funnels: {},
  firebaseId: null
}

export default {
  state,
  getters,
  actions,
  mutations
}
